module.exports = __webpack_public_path__ + "img/Left_menu.0c123f35.png";